export default "__VITE_ASSET__Bgua6DrH__"